import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  PaymentConfigurationActions,
  PaymentConfigurationActionTypes,
} from "./../actions/payment-configuration.action";
import { map, switchMap } from "rxjs/operators";
import { PaymentEngineService } from "./../../services/payment-engine.service";
import { PaymentEngine } from "../../services/payment-engine";
import { State } from "./../reducers";
import * as fromPaymentProcess from "./../reducers/payment-process.reducer";
import { from } from "rxjs";
import { PaymentProcessActions } from "./../actions/payment-process.action";

@Injectable()
export class PaymentConfigurationEffect {
  constructor(
    protected actions$: Actions,
    protected store$: Store<State>,
    private paymentEngineService: PaymentEngineService
  ) {}

  loadPaymentConfiguration$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PaymentConfigurationActions.LoadPaymentConfiguration>(
        PaymentConfigurationActionTypes.LOAD_PAYMENT_CONFIGURATION
      ),
      switchMap(() => {
        return this.paymentEngineService.paymentEngine.getPaymentConfiguration().pipe(
          switchMap((paymentConfiguration) => {
            return from([
              new PaymentConfigurationActions.AddPaymentConfiguration(paymentConfiguration),
              new PaymentProcessActions.SetDocumentsAmountDue(),
            ]);
          })
        );
      })
    )
  );
}
